import axios from 'axios'
import config from '../../global/configure'

// 校验用户token状态
export function chekcUserLogin (datas) {
  const url = '/userCommon/chekcUserLogin'
  return new Promise((resolve, reject) => {
    axios.get(url, { params: datas }).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 获取点对点总入口未读红点显示
export function getPointUnRead (datas) {
  const url = `${config.p2p_url}/pointServer/pointToPoint/getPointUnRead`
  return new Promise((resolve, reject) => {
    axios.get(url, {params: datas}).then((res) => {
      resolve(res)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 获取点对点最后一条未读消息
export function queryLastUnreadMessage (datas) {
  const url = `${config.p2p_url}/pointServer/pointToPoint/queryLastUnreadMessage`
  return new Promise((resolve, reject) => {
    axios.post(url, datas).then((res) => {
      resolve(res.data)
    }).catch((err) => {
      reject(err)
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/chat/index.js